import { render, staticRenderFns } from "./guanyuWomen.vue?vue&type=template&id=d15d40f2"
import script from "./guanyuWomen.vue?vue&type=script&lang=js"
export * from "./guanyuWomen.vue?vue&type=script&lang=js"
import style0 from "./guanyuWomen.vue?vue&type=style&index=0&id=d15d40f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports